<template>
  <div>
     <el-card>
      <search-form
        ref="searchForm"
        :topVisible="true"
        :tabData="tabData"
        labelWidth="120px"
        :searchFormData="searchFormData"
        @search="search" @tabChange="tabChange"
      />
      <create-table
        ref="createTable"
        :operationColWidth="150"
        :autoWidth="true"
        :operateVisible="operateVisible"
        :loading="loading"
        :btnType="[]"
        :total_count="pageData.total_count ? pageData.total_count : 0"
        :current_page.sync="pageData.page"
        :papeSize.sync="pageData.per_page"
        :topButtonVisible="true"
        :tableData="tableData"
        :tableDataItem="tableDataItem"
        :pageVisible="true"
        :pageData="pageData"
        @forwardToPage="forwardToPage"
        :checkBoxVisible="dropDataItem.length > 0" @handleSort="handleSort"
        @handleNewTab="handleNewTab($event, 'storesManagerDetail')"
        @selectionChange="selectionChange"
        @operate="handleClick"
      >
        <template #topButton>
          <span v-if="dropDataItem.length > 0" class="marginRight20 spanminWith">{{`${$t('text.selected')}：${selectionData.length}`}}</span>
          <allButton :buttonDisabled="selectionData.length < 1" :buttonDataItem="dropDataItem" class="marginRight20" @chooseDropItem="chooseDropItem"></allButton>
        </template>
        <template #rightBtn="scope">
          <!-- <el-button class="margintop10" v-if="scope.row.status.value === 'Charging'" type="primary" @click="hanleMessage">Remote Stop</el-button> -->
          <el-button class="margintop10" v-if="scope.row.status.value === 'Preparing'" type="primary" @click="hanleMessage">Remote Start</el-button>
          <el-button class="margintop10" :class="item.action === 'view' ? 'operate_view' : ''" v-for="(item, index) in scope.row.member_actions.default_actions" :key="'default_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
          <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.custom_actions" :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleCusClick(item)">{{item.name}}</el-button>
        </template>
      </create-table>
    </el-card>
    <router-view/>
    <dialogEffect v-if="dialogVisible" :opereteDate="false" :todayVisible="true" :dialogVisible.sync="dialogVisible" :data="dialogData" @doNextConfirm="doNextConfirm"></dialogEffect>
  </div>
</template>

<script>
import loading from '@/utils/loading.json'
import apis from '@/services'
import jsonData from './jsonData.js'
import allButton from '@/components/allButton'
import searchForm from '@/components/searchForm'
import createTable from '@/components/createTable'
import dialogEffect from '@/components/dialogEffect'
import { mixin } from '@/mixins/mixin'
export default {
  name: 'ChargingSession',
  mixins: [mixin],
  components: {
    searchForm,
    createTable,
    allButton,
    dialogEffect
  },
  data () {
    return {
      tableDataItem: jsonData.tableDataItem
    }
  },
  created () {
    this.queryData(apis.ActivitiesApi.getChargingSessionsSetup)
  },
  methods: {
    // 点击操作按钮
    async handleClick (type, data) {
      console.log(type)
      if (type.action === 'view') {
        this.$router.push({
          name: 'chargingSessionDetail',
          params: {
            id: data.id.value
          }
        })
      }
    },
    forwardToPage (data, name) {
      if (data.model_name && data.model_name === 'user') {
        this.$router.push({
          name: 'usersDetail',
          params: {
            id: data.id
          }
        })
      }
      if (data.model_name && data.model_name === 'evse') {
        this.$router.push({
          name: 'EVSEsDetail',
          params: {
            id: data.id
          }
        })
      }
      if (data.model_name && data.model_name === 'charge_point') {
        this.$router.push({
          name: 'chargingPointDetail',
          params: {
            id: data.id
          }
        })
      }
      if (data.model_name && data.model_name === 'location') {
        this.$router.push({
          name: 'locationDetail',
          params: {
            id: data.id
          }
        })
      }
    },
    search (data) {
      if (data) this.searchData = data
      const { page, per_page } = this.pageData
      Object.assign(this.searchData, { page, per_page })
      this.loading = true
      apis.ActivitiesApi.getChargingSessionsList(this.searchData).then(res => {
        if (res.data) {
          this.tableData = res.data.objects
          this.tabData = res.data.scopes
          Object.assign(this.pageData, res.data.pagination)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    hanleMessage () {
      this.$store.state.app.loading = this.$loading(loading)
      setTimeout(() => {
        this.$store.state.app.loading.close()
        this.$message({
          message: 'The EVSE is currently unavailable.',
          type: 'error'
        })
      }, 500)
    }
  }
}
</script>

<style>
</style>
